export const mockMemberNames: Record<string, string> = {
  "1": "Sho Aoki",
  "2": "Akira menai",
  "3": "野澤 哲也",
  "4": "Max Verstappen",
  "5": "Taro Yamada",
  "6": "Haruto Sato",
  "7": "Ren Takahashi",
  "8": "Yuki Tanaka",
  "9": "Kento Ito",
  "10": "Sota Watanabe",
  "11": "Riku Nakamura",
  "12": "Kai Kobayashi",
  "13": "Daiki Kato",
  "14": "Shun Yoshida",
  "15": "Yuma Yamaguchi",
  "16": "Koki Matsumoto",
};
